import SpaceBetween from '@risk-smart/themed-cloudscape-components/space-between';
import Button from '@risksmart-app/components/src/button';
import Table from '@risksmart-app/components/src/table';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TabHeader from 'src/components/tab-header';
import { useGetCollectionTableProps } from 'src/pages/data-import/config';

import { useGetDataImports } from '@/hooks/queries';

const DataImportTab: FC = () => {
  const { data, loading } = useGetDataImports({ queryArgs: {} });
  const { t } = useTranslation(['common'], { keyPrefix: 'dataImport' });
  const tableProps = useGetCollectionTableProps(data?.data_import ?? []);

  return (
    <>
      <Table
        {...tableProps}
        header={
          <SpaceBetween size={'m'}>
            <TabHeader
              actions={
                <SpaceBetween direction={'horizontal'} size={'xs'}>
                  <Button variant={'primary'} href={'add'}>
                    {t('create_new_button')}
                  </Button>
                </SpaceBetween>
              }
            >
              {t('tabTitle')}
            </TabHeader>
          </SpaceBetween>
        }
        variant={'embedded'}
        loading={loading}
        trackBy={'Id'}
      />
    </>
  );
};

export default DataImportTab;
